import { AdminUsersScreen } from '@features/admin/ui/AdminUsersScreen'

export function UsuariosPage() {
  return <AdminUsersScreen />
}
